import styled from 'styled-components';
import { cssVars } from '../../../shared/lib/styledTheme';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background-color: ${cssVars.bgSecondary};
  border-radius: 8px;
  width: 90%;
  max-width: 600px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
`;

export const ModalHeader = styled.div`
  padding: 20px 24px;
  border-bottom: 1px solid ${cssVars.borderColor};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ModalTitle = styled.h2`
  font-size: 20px;
  font-weight: 600;
  color: ${cssVars.textPrimary};
  margin: 0;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 28px;
  color: ${cssVars.textSecondary};
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${cssVars.hover};
  }
`;

export const ModalBody = styled.div`
  padding: 24px;
  overflow-y: auto;
  flex: 1;
`;

export const ModalFooter = styled.div`
  padding: 16px 24px;
  border-top: 1px solid ${cssVars.borderColor};
  display: flex;
  justify-content: flex-end;
  gap: 12px;
`;

export const FormGroup = styled.div`
  margin-bottom: 20px;
`;

export const Label = styled.label`
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: ${cssVars.textPrimary};
  margin-bottom: 8px;
`;

export const Textarea = styled.textarea`
  width: 100%;
  padding: 12px;
  border: 1px solid ${cssVars.borderColor};
  border-radius: 6px;
  background-color: ${cssVars.bgColor};
  color: ${cssVars.textPrimary};
  font-size: 14px;
  font-family: inherit;
  resize: vertical;
  outline: none;

  &:focus {
    border-color: ${cssVars.primary};
  }
`;

export const Button = styled.button<{ $variant?: 'primary' | 'secondary' }>`
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;

  ${props => props.$variant === 'primary' ? `
    background-color: ${cssVars.primary};
    color: ${cssVars.white};

    &:hover:not(:disabled) {
      background-color: ${cssVars.primaryHover};
    }
  ` : `
    background-color: ${cssVars.bgColor};
    color: ${cssVars.textPrimary};
    border: 1px solid ${cssVars.borderColor};

    &:hover {
      background-color: ${cssVars.hover};
    }
  `}

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const RecipientInfo = styled.div`
  margin-bottom: 20px;
  padding: 12px;
  background-color: ${cssVars.bgColor};
  border-radius: 6px;
  border: 1px solid ${cssVars.borderColor};
`;

export const RecipientLabel = styled.span`
  font-size: 12px;
  color: ${cssVars.textSecondary};
  display: block;
  margin-bottom: 4px;
`;

export const RecipientValue = styled.span`
  font-size: 14px;
  color: ${cssVars.textPrimary};
  font-weight: 500;
`;

export const FileInputWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const FileInput = styled.input`
  display: none;
`;

export const FileInputButton = styled.button`
  padding: 8px 16px;
  background-color: ${cssVars.bgColor};
  color: ${cssVars.textPrimary};
  border: 1px solid ${cssVars.borderColor};
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: ${cssVars.hover};
    border-color: ${cssVars.primary};
  }
`;

export const AttachmentsList = styled.div`
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const AttachmentItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background-color: ${cssVars.bgColor};
  border: 1px solid ${cssVars.borderColor};
  border-radius: 6px;
`;

export const AttachmentName = styled.span`
  font-size: 13px;
  color: ${cssVars.textPrimary};
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const RemoveButton = styled.button`
  background: none;
  border: none;
  font-size: 20px;
  color: ${cssVars.textSecondary};
  cursor: pointer;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${cssVars.hover};
    color: ${cssVars.textPrimary};
  }
`;

